<panel width="700">
	<h1>{{ 'sale.my-orders.header' | translate }}</h1>
	<list-orders [sellerId]="userService.getCurrentUser().id" [groupBy]="orderCompletedStatus" />
</panel>
